@if (tourActive) {
  <!-- Dark overlay with spotlight cutout -->
  <svg
    class="gt-overlay"
    xmlns="http://www.w3.org/2000/svg"
    [attr.width]="svgWidth"
    [attr.height]="svgHeight">
    <path fill-rule="evenodd" fill="rgba(0,0,0,0.7)" [attr.d]="overlayPath" />
  </svg>

  <!-- Click-blocker -->
  <div class="gt-blocker"></div>

  <!-- Spotlight ring -->
  @if (spotlightRect) {
    <div
      class="gt-spotlight"
      [style.top.px]="spotlightRect.top"
      [style.left.px]="spotlightRect.left"
      [style.width.px]="spotlightRect.width"
      [style.height.px]="spotlightRect.height">
    </div>
  }

  <!-- Tooltip card -->
  <div
    class="gt-tooltip"
    [class.gt-tooltip--top]="resolvedPos === 'top'"
    [class.gt-tooltip--bottom]="resolvedPos === 'bottom'"
    [class.gt-tooltip--left]="resolvedPos === 'left'"
    [class.gt-tooltip--right]="resolvedPos === 'right'"
    [style.top.px]="tooltipTop"
    [style.left.px]="tooltipLeft"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="currentStep?.title">

    <!-- Animated accent progress bar -->
    <div class="gt-tooltip__progress-track" aria-hidden="true">
      <div class="gt-tooltip__progress-fill" [style.width.%]="progressPercent"></div>
    </div>

    <!-- Header: icon + rank info + close -->
    <div class="gt-tooltip__header">
      <div class="gt-tooltip__icon-wrap">
        @switch (currentStepIndex) {
          @case (0) {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="4" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/></svg>
          }
          @case (1) {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>
          }
          @case (2) {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v8"/><path d="M8 12h8"/></svg>
          }
          @case (3) {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>
          }
          @case (4) {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
          }
          @case (5) {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
          }
          @case (6) {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          }
          @case (7) {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>
          }
          @default {
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          }
        }
      </div>

      <div class="gt-tooltip__step-info">
        <div class="gt-tooltip__rank">{{ rankEmoji }} {{ rankLabel }}</div>
        <div class="gt-tooltip__step-count">Step {{ currentStepIndex + 1 }} of {{ totalSteps }}</div>
      </div>

      <button type="button" class="gt-tooltip__close" aria-label="Skip tour" (click)="skip()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <!-- Title + description -->
    <div class="gt-tooltip__body">
      <h3 class="gt-tooltip__title">{{ currentStep?.title }}</h3>
      <p class="gt-tooltip__desc">{{ currentStep?.description }}</p>
    </div>

    <!-- Progress dots -->
    <div class="gt-tooltip__dots" aria-hidden="true">
      @for (s of steps; track s.index) {
        <span
          class="gt-tooltip__dot"
          [class.gt-tooltip__dot--active]="s.index === currentStepIndex"
          [class.gt-tooltip__dot--done]="s.index < currentStepIndex">
        </span>
      }
    </div>

    <!-- Actions -->
    <div class="gt-tooltip__actions">
      <button type="button" class="gt-tooltip__btn gt-tooltip__btn--ghost" (click)="skip()">
        Skip Tour
      </button>
      <div class="gt-tooltip__nav">
        @if (currentStepIndex > 0) {
          <button type="button" class="gt-tooltip__btn gt-tooltip__btn--secondary" (click)="prev()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
            Back
          </button>
        }
        <button
          type="button"
          class="gt-tooltip__btn gt-tooltip__btn--primary"
          (click)="next()">
          @if (isFinishStep) {
            🎉 Let's Go!
          } @else {
            Next
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- Confetti — lives outside tourActive so it plays after the tour closes -->
@if (confettiActive) {
  <div class="gt-confetti-container" aria-hidden="true">
    @for (p of confettiParticles; track $index) {
      <div
        class="gt-confetti-piece"
        [class.gt-confetti-piece--circle]="p.isCircle"
        [style.left.%]="p.x"
        [style.background]="p.color"
        [style.width.px]="p.size"
        [style.height.px]="p.isCircle ? p.size : p.size * 1.6"
        [style.animation-delay.ms]="p.delay"
        [style.animation-duration.ms]="p.duration">
      </div>
    }
  </div>
}
